// HTTP client for the server-side automation engine (/admin/automation-flows), migrated to the
// OpenAPI-generated client (AdminAutomationFlowController). Each function keeps its old return shape
// (callers read res.data / res.data.id) — the adapter returns `{data}` and re-throws an axios-shaped
// `{response:{data,status}}` on error. Auth/timezone headers come from configureApi's interceptor.

import {
    adminAutomationFlowControllerList,
    adminAutomationFlowControllerGet,
    adminAutomationFlowControllerCreate,
    adminAutomationFlowControllerUpdate,
    adminAutomationFlowControllerDelete,
    adminAutomationFlowControllerEnable,
    adminAutomationFlowControllerDisable,
    adminAutomationFlowControllerTestRun,
    adminAutomationFlowControllerListExecutions,
    adminAutomationFlowControllerGetExecution,
    adminAutomationFlowControllerBricks,
} from '../api/generated';

// Preserve the legacy axios rejection shape so call sites reading `e.response.data.errorMessage` keep working.
const throwLikeAxios = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

// ── Flow CRUD ────────────────────────────────────────────────────────────────
export const listFlows = async (companyId) => {
    const {data, error, response} = await adminAutomationFlowControllerList({
        query: companyId ? {companyId} : {},
    });
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const getFlow = async (id) => {
    const {data, error, response} = await adminAutomationFlowControllerGet({path: {id}});
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const createFlow = async (body, companyId) => {
    const {data, error, response} = await adminAutomationFlowControllerCreate({
        body,
        query: companyId ? {companyId} : {},
    });
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const updateFlow = async (id, body) => {
    const {data, error, response} = await adminAutomationFlowControllerUpdate({path: {id}, body});
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const deleteFlow = async (id) => {
    const {data, error, response} = await adminAutomationFlowControllerDelete({path: {id}});
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const enableFlow = async (id) => {
    const {data, error, response} = await adminAutomationFlowControllerEnable({path: {id}});
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const disableFlow = async (id) => {
    const {data, error, response} = await adminAutomationFlowControllerDisable({path: {id}});
    if (error) throwLikeAxios(error, response);
    return {data};
};

// ── Test run ────────────────────────────────────────────────────────────────
// triggerData: { [namespace]: { field: value } }, e.g. { arbox: { email, user_role } }.
export const testRunFlow = async (id, triggerData) => {
    const {data, error, response} = await adminAutomationFlowControllerTestRun({
        path: {id},
        body: {triggerData: triggerData || {}},
    });
    if (error) throwLikeAxios(error, response);
    return {data};
};

// ── Run history ───────────────────────────────────────────────────────────────
export const listExecutions = async (id, limit = 50) => {
    const {data, error, response} = await adminAutomationFlowControllerListExecutions({
        path: {id},
        query: {limit},
    });
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const getExecution = async (executionId) => {
    const {data, error, response} = await adminAutomationFlowControllerGetExecution({path: {executionId}});
    if (error) throwLikeAxios(error, response);
    return {data};
};

// ── Brick catalog (drives the palette + trigger picker) ────────────────────────
export const getBrickCatalog = async () => {
    const {data, error, response} = await adminAutomationFlowControllerBricks();
    if (error) throwLikeAxios(error, response);
    return {data};
};
